(() => {
  const DAY = 86400000;
  const SOURCE_URL = 'https://maps.google.com/maps?cid=13624188722754721572';

  function googleLink(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password && ['maps.google.com', 'www.google.com', 'share.google'].includes(url.hostname) ? url.href : SOURCE_URL;
    } catch { return SOURCE_URL; }
  }

  function element(tag, className, text) {
    const result = document.createElement(tag);
    if (className) result.className = className;
    if (text !== undefined) result.textContent = text;
    return result;
  }

  function init(root) {
    if (root.dataset.gcReady) return;
    root.dataset.gcReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-gc-review-labels]').textContent);
    const grid = root.querySelector('[data-gc-review-grid]');
    const rating = root.querySelector('[data-gc-review-rating]');
    const selection = root.querySelector('[data-gc-review-selection]');
    const freshness = root.querySelector('[data-gc-review-freshness]');
    const originalGrid = [...grid.children].map(card => card.cloneNode(true));
    const originalRating = [...rating.children].map(child => child.cloneNode(true));
    let expiryTimer;
    root.dataset.enhanced = 'true';

    function fitButtons() {
      root.querySelectorAll('[data-gc-review-expand]').forEach(button => {
        const text = document.getElementById(button.getAttribute('aria-controls'));
        button.hidden = !text || (button.getAttribute('aria-expanded') !== 'true' && text.scrollHeight <= text.clientHeight + 2);
      });
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-gc-review-expand]');
      if (!button || !root.contains(button)) return;
      const text = document.getElementById(button.getAttribute('aria-controls'));
      if (!text) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? labels.showLess : labels.readFull;
      text.classList.toggle('is-expanded', expanded);
    });

    function restore() {
      clearTimeout(expiryTimer);
      grid.replaceChildren(...originalGrid.map(card => card.cloneNode(true)));
      rating.replaceChildren(...originalRating.map(child => child.cloneNode(true)));
      selection.textContent = labels.selected;
      freshness.hidden = true;
      freshness.textContent = '';
      root.dataset.feedStatus = 'unavailable';
      requestAnimationFrame(fitButtons);
    }

    function stars(value, label) {
      const container = element('span', 'gc-reviews__stars', '★★★★★');
      container.setAttribute('role', 'img');
      container.setAttribute('aria-label', label);
      const filled = element('span', '', '★★★★★');
      filled.style.width = `${value / 5 * 100}%`;
      filled.setAttribute('aria-hidden', 'true');
      container.append(filled);
      return container;
    }

    function link(text, url) {
      const anchor = element('a', '', text.replaceAll('↗', '↗\uFE0E'));
      anchor.href = googleLink(url);
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      return anchor;
    }

    function valid(data) {
      const checked = Date.parse(data.checkedAt);
      const expires = Date.parse(data.expiresAt);
      return data.schemaVersion === 1 && ['fresh', 'stale'].includes(data.status) && data.source?.placeId === root.dataset.placeId && data.selection === 'latest_updated_written' && Number.isFinite(checked) && Number.isFinite(expires) && checked <= Date.now() + 300000 && expires > Date.now() && expires <= checked + 3 * DAY && Number.isFinite(data.averageRating) && data.averageRating >= 1 && data.averageRating <= 5 && Number.isInteger(data.totalReviewCount) && data.totalReviewCount >= 0 && Array.isArray(data.reviews) && data.reviews.length > 0 && data.reviews.length <= 3 && data.reviews.every(review => typeof review.id === 'string' && typeof review.author === 'string' && typeof review.text === 'string' && Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5 && Number.isFinite(Date.parse(review.createdAt)));
    }

    function render(data) {
      if (!valid(data)) { restore(); return; }
      const cards = data.reviews.map((review, index) => {
        const card = element('article', 'gc-reviews__card');
        const person = element('div', 'gc-reviews__person');
        const initial = element('span', 'gc-reviews__initial', review.author.slice(0, 1));
        initial.setAttribute('aria-hidden', 'true');
        const author = element('div');
        author.append(element('h3', '', review.author), element('p', 'gc-reviews__source', labels.googleSource));
        person.append(initial, author);
        const meta = element('div', 'gc-reviews__meta');
        const date = element('time', '', new Date(review.createdAt).toLocaleDateString(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' }));
        date.dateTime = review.createdAt;
        meta.append(stars(review.rating, labels.starsLabel.replace('[rating]', String(review.rating))), date);
        const quote = element('blockquote', 'gc-reviews__quote');
        const text = element('div', 'gc-reviews__text', review.text);
        text.id = `${root.id || root.querySelector('h2').id}-google-review-${index}`;
        quote.append(text);
        const actions = element('div', 'gc-reviews__actions');
        const expand = element('button', 'gc-reviews__expand', labels.readFull);
        expand.type = 'button';
        expand.dataset.gcReviewExpand = '';
        expand.setAttribute('aria-expanded', 'false');
        expand.setAttribute('aria-controls', text.id);
        actions.append(expand, link(`${labels.viewGoogle} ↗`, review.sourceUrl));
        card.append(person, meta, quote, actions);
        return card;
      });
      const score = element('strong', '', data.averageRating.toFixed(1));
      score.setAttribute('aria-label', labels.starsLabel.replace('[rating]', data.averageRating.toFixed(1)));
      score.append(element('small', '', ` ${labels.outOfFive}`));
      const detail = element('div', 'gc-reviews__rating-details');
      detail.append(stars(data.averageRating, labels.starsLabel.replace('[rating]', data.averageRating.toFixed(1))), link(labels.reviewCount.replace('[count]', String(data.totalReviewCount)), data.source.mapsUrl));
      grid.replaceChildren(...cards);
      rating.replaceChildren(score, detail);
      selection.textContent = labels.latest;
      const date = new Date(data.checkedAt).toLocaleDateString(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' });
      freshness.textContent = `${labels.checked.replace('[date]', date)}${Date.now() - Date.parse(data.checkedAt) > DAY ? ` ${labels.previousCheck}` : ''}`;
      freshness.hidden = false;
      root.dataset.feedStatus = data.status;
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(restore, Date.parse(data.expiresAt) - Date.now());
      requestAnimationFrame(fitButtons);
    }

    async function load() {
      try {
        const endpoint = new URL(root.dataset.feedUrl);
        if (endpoint.origin !== 'https://command.goldencollections.com' || endpoint.pathname !== '/api/storefront/google-reviews' || endpoint.search) return;
        const response = await fetch(endpoint.href, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(3000) });
        if (!response.ok) return;
        render(await response.json());
      } catch { root.dataset.feedStatus = 'unavailable'; }
    }

    requestAnimationFrame(fitButtons);
    new ResizeObserver(fitButtons).observe(grid);
    if (root.dataset.feedUrl && !window.Shopify?.designMode) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); void load(); }
      }, { rootMargin: '200px' });
      observer.observe(root);
    }
  }

  function initAll() { document.querySelectorAll('[data-gc-reviews]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
